import {
    ResponsiveContainer,
    breakpoints,
    media,
    style
} from 'app/assets/styles'
import { DropdownButton } from 'app/common/dropdown'
import { Filter, Filters } from 'app/common/filters'
import { ModalTitle } from 'app/common/modals/title'
import { H2 } from 'app/common/typography'
import React, { Fragment, useState } from 'react'
import type { IntlShape } from 'react-intl'
import { injectIntl } from 'react-intl'
import Modal from 'react-modal'
import Responsive from 'react-responsive'
import type { FilterShortDTO } from 'shared/types'
import { updateFiltersArray } from 'shared/utils'
import styled from 'styled-components'
import { SPACING } from 'app-v2/design-tokens'
const { dropdownModalStyle } = style

type Props = {
    withoutBacon: boolean,
    toggleWithoutBacon: () => void,
    actualSelectedAllergens: Array<string>,
    allergens: Array<FilterShortDTO>,
    selectAllergens: (Array<string>) => void,
    intl: IntlShape
}

const _CatalogAllergens = ({
    withoutBacon,
    toggleWithoutBacon,
    actualSelectedAllergens,
    allergens,
    selectAllergens,
    intl
}: Props) => {
    const breakpoint = breakpoints.medium
    const [selectedAllergens, setSelectedAllergens] = useState(
        actualSelectedAllergens
    )
    const [showAllergens, setShowAllergens] = useState(false)

    const filterByAllergens = () => {
        selectAllergens(selectedAllergens)
        toggleAllergens()
    }

    const displayDropdown = () => {
        if (!showAllergens) {
            setShowAllergens(true)
        }
    }

    const toggleAllergens = () => {
        setShowAllergens(!showAllergens)
    }

    const updateAllergens = (allergen: FilterShortDTO) => {
        const newSelectedAllergens = updateFiltersArray(
            [...selectedAllergens],
            allergen.code
        )
        setSelectedAllergens(newSelectedAllergens)
    }

    const resetAllergens = () => {
        if (selectedAllergens.length > 0) {
            setSelectedAllergens([])
        }
    }

    return (
        <Toolbar>
            <ToolbarSlot toLeft>
                <Filter
                    checked={withoutBacon}
                    name={intl.formatMessage({
                        id: 'clickandcollect.catalog.filter.bacon'
                    })}
                    updateFilters={toggleWithoutBacon}
                />
            </ToolbarSlot>
            <ToolbarSlot toRight>
                <StyledDropdownButtonContainer onClick={displayDropdown}>
                    <DropdownButton
                        label={intl.formatMessage({
                            id: 'catalog.filters.by.label'
                        })}
                        collapsed={showAllergens}>
                        <Fragment>
                            <Responsive maxWidth={breakpoint - 1}>
                                <Modal
                                    isOpen={showAllergens}
                                    ariaHideApp={false}
                                    style={dropdownModalStyle}>
                                    <ResponsiveContainer>
                                        <ModalTitle
                                            titleNode={
                                                <StyledH2>
                                                    {intl.formatMessage({
                                                        id:
                                                            'modal.filters.title'
                                                    })}
                                                </StyledH2>
                                            }
                                            handleClose={toggleAllergens}
                                        />
                                        <Filters
                                            filters={allergens}
                                            selectedFilters={selectedAllergens}
                                            handleReset={resetAllergens}
                                            handleApply={filterByAllergens}
                                            handleClose={toggleAllergens}
                                            handleUpdate={allergen =>
                                                updateAllergens(allergen)
                                            }
                                        />
                                    </ResponsiveContainer>
                                </Modal>
                            </Responsive>
                            <Responsive minWidth={breakpoint}>
                                {showAllergens && (
                                    <Filters
                                        clickOutside
                                        filters={allergens}
                                        selectedFilters={selectedAllergens}
                                        handleReset={resetAllergens}
                                        handleApply={filterByAllergens}
                                        handleClose={toggleAllergens}
                                        handleUpdate={allergen =>
                                            updateAllergens(allergen)
                                        }
                                    />
                                )}
                            </Responsive>
                        </Fragment>
                    </DropdownButton>
                </StyledDropdownButtonContainer>
            </ToolbarSlot>
        </Toolbar>
    )
}

const Toolbar = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: ${SPACING.S};
`

const ToolbarSlot = styled.div`
    flex: 1;
    flex-direction: row;
    ${props =>
        props.toLeft &&
        `
            justify-content: flex-start;
        `};
    ${props =>
        props.toRight &&
        `
            justify-content: flex-end;
        `};
`

const StyledDropdownButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    position: relative;
    width: 100%;
    ${media.medium`
        justify-content: flex-end;
    `};
`

const StyledH2 = styled(H2)`
    margin: 0;
`

export const CatalogAllergens = injectIntl(_CatalogAllergens)
